import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "22",
      height: "22",
      fill: "currentColor",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#fff",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.33",
      d: "M7 15h1.076c.314 0 .471 0 .62-.036q.197-.047.37-.153c.13-.08.241-.19.464-.413l5.07-5.071a1.363 1.363 0 1 0-1.927-1.928l-5.07 5.071h0c-.223.223-.334.334-.414.463q-.106.173-.154.372C7 13.453 7 13.61 7 13.925z",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }